export const columnsDataPersonaPurchaseHistory = [
  {
    Header: "NAME",
    accessor: "user.name",
  },
  {
    Header: "ACTION",
    accessor: "product",
  },
  {
    Header: "MULAI",
    accessor: "created_at",
  },
  {
    Header: "SELESAI",
    accessor: "expired_at",
  },
];